'use client'

import { Box, BoxProps, Text } from '@chakra-ui/react'
import { ItemApi } from 'appTypes/items'
import { useMemo } from 'react'
import { ParsedPricingInfo } from 'utils/apiUtils/prices'
import { Location } from '@leid/api-locations'
import PeriodInfoContent from './PeriodInfoContent'
import { useTranslation } from 'react-i18next'

type Props = BoxProps & {
  product: ItemApi
  location?: Location
}

const PeriodInfoContentWrapper = ({ product, location }: Props) => {
  const { t } = useTranslation('common')
  const getPricingInfoForLocation = (location: Location | undefined, pricingInfo: ParsedPricingInfo[] | undefined) => {
    if (!pricingInfo) {
      return undefined
    }

    if (!location) {
      return pricingInfo[0]
    }

    if (location.priceGroupId) {
      const info = pricingInfo.find((s) => s.priceGroupId === location.priceGroupId)
      if (info) {
        return info
      }
    }

    const defaultInfo = pricingInfo.find((s) => s.priceGroupId === undefined)
    if (defaultInfo) {
      return defaultInfo
    }
    return pricingInfo[0]
  }
  const pricingInfo = useMemo(
    () => getPricingInfoForLocation(location, product.pricingInfo),
    [location, product.pricingInfo],
  )

  if (!product.pricingInfo || product.pricingInfo.length === 0) {
    return null
  }
  return (
    <>
      {pricingInfo && (
        <Box marginY={10}>
          <Text fontWeight="semibold" fontSize={{ base: 'md', lg: 'xl' }} marginBottom={2}>
            {t('priceBreakdown')}
          </Text>
          <Text fontSize="sm">{t('pricingInfoDescription.pricingDescription')}</Text>
          <PeriodInfoContent pricingInfo={pricingInfo} />
        </Box>
      )}
    </>
  )
}

export default PeriodInfoContentWrapper
